import React from "react";
import styles from './AppLayoutHeader.module.scss'
import { Grid, Avatar, Tooltip } from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import { AuthorizedUserInfoDto } from "../../../_models";

const AppLayoutHeader: React.FC<{
    drawerWidth: number,
    drawerStatus: boolean,
    userInfo: AuthorizedUserInfoDto,
    onSignOut: () => void
}> = (props) => {

    return (
        <header
            className={styles.appHeader}
            style={{ width: `calc(100% - ${props.drawerWidth}px)`, marginLeft: props.drawerWidth }}
        >
            <Grid container>
                <Grid container item xs={6} alignContent="flex-start" alignItems="center">
                    <span className={styles.appLogo}></span>
                    <span className={styles.appName}><strong>Clock!</strong> - Time Study App</span>
                </Grid>
                <Grid container item xs={6} alignContent="center" justify="flex-end">
                    {/* <AppHeaderProfile /> */}
                    <div className={styles.profileHolder}>
                        <aside >
                            <Avatar />
                        </aside>
                        <aside>
                            <p className={styles.user}>
                                {props.userInfo.firstName + ' ' + props.userInfo.lastName}
                            </p>
                            <p className={styles.email}>{props.userInfo.isAdmin ? 'Admin' : 'User'}</p>
                        </aside>
                        <aside className={styles.logout}>
                            <Tooltip title="Sign-out">
                                <ExitToApp
                                    fontSize="small"
                                    onClick={props.onSignOut}
                                />
                            </Tooltip>
                        </aside>
                    </div>
                </Grid>
            </Grid>
        </header>
    );
}

export default AppLayoutHeader;
